export const REDIRECTION_PAGES = {
  catalog: "Catalog",
  static: "Static",
  staticAccordion: "Static Accordion",
  productListing: "Product Listing",
  productCatalog: "Product Catalog",
  flashSale: "Flash Sale"
};
